import { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Card, CardBody, CardHeader, FormGroup, Input, Label, Spinner } from 'reactstrap';

import { getTwoFactorConfiguration, updateTwoFactorConfiguration } from '../../../helpers/bff_helper';
import { useProfile } from '../../../Components/Hooks/UserHooks';

const isAdmin = (roleName) => String(roleName || '').toLowerCase().includes('administrador');

const TwoFactorAuth = (props) => {
  const { userProfile } = useProfile();
  const [enabled, setEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    getTwoFactorConfiguration()
      .then((config) => {
        const enabledValue = config?.values?.find((value) => value.key === 'enabled');
        setEnabled(enabledValue?.value === 'true');
      })
      .catch(() => setEnabled(false))
      .finally(() => setIsLoading(false));
  }, []);

  const handleToggle = async (event) => {
    const nextValue = event.target.checked;
    setIsSaving(true);

    try {
      await updateTwoFactorConfiguration(nextValue);
      setEnabled(nextValue);
      toast.success(props.t('general-settings.two-factor.success'));
    } catch (error) {
      toast.error(props.t('general-settings.two-factor.error'));
    } finally {
      setIsSaving(false);
    }
  };

  if (!isAdmin(userProfile?.role?.name)) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <h4 className="mb-1">{props.t('general-settings.two-factor.title')}</h4>
        <span className="text-muted">{props.t('general-settings.two-factor.description')}</span>
      </CardHeader>

      <CardBody>
        <FormGroup switch>
          <Input
            type="switch"
            role="switch"
            id="two-factor-enabled"
            checked={enabled}
            disabled={isLoading || isSaving}
            onChange={handleToggle}
          />
          <Label htmlFor="two-factor-enabled" check>
            {enabled
              ? props.t('general-settings.two-factor.enabled')
              : props.t('general-settings.two-factor.disabled')}
          </Label>
          {isSaving && <Spinner size="sm" className="ms-2" />}
        </FormGroup>
      </CardBody>
    </Card>
  );
};

export default withTranslation()(TwoFactorAuth);
